import { ArrowBack } from "@mui/icons-material";
import { Box, Container, Divider, IconButton, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { Fragment } from "react/jsx-runtime";

type SubheaderProps = {
    title: string,
    backAction?: () => void
}

export default function Subheader(props: PropsWithChildren<SubheaderProps>) {
    return (
        <Box bgcolor="background.header">
            <Container maxWidth="xl">
                <Box display="flex" columnGap={2} paddingY={1}>
                    {props.backAction &&
                        <Fragment>
                            <IconButton aria-label="back" onClick={props.backAction}>
                                <ArrowBack sx={{ fontSize: 25 }} />
                            </IconButton>
                            <Divider orientation="vertical" flexItem />
                        </Fragment>
                    }
                    <Typography variant="h4" color="background.contrastText" alignContent='center'>{props.title}</Typography>
                    <Box flex={1} />
                    {props.children}
                </Box>
            </Container>
        </Box>)
}
